import { MediaType } from '../../types/media-item';
function paramsAreValid(media, dimensions) {
    return (!!media &&
        (media.mediaType === MediaType.PHOTO.toString() || media.mediaType === MediaType.VIDEO.toString()) &&
        typeof media.url === 'string' &&
        !!dimensions &&
        (typeof dimensions.width === 'number' || typeof dimensions.height === 'number'));
}
export function getMediaUrlDimensions(media, dimensions) {
    if (!paramsAreValid(media, dimensions)) {
        return null;
    }
    var newHeight;
    var newWidth;
    var mediaWidth = media.width;
    var mediaHeight = media.height;
    var mediaRatio = mediaWidth / mediaHeight;
    var width = dimensions.width || dimensions.height * mediaRatio;
    var height = dimensions.height || dimensions.width / mediaRatio;
    var minWidth = Math.min(width, mediaWidth);
    var minHeight = Math.min(height, mediaHeight);
    var ratio = width / height;
    if (ratio === 1) {
        newWidth = newHeight = Math.round(Math.min(width, mediaWidth, mediaHeight));
    }
    if (ratio > 1) {
        newWidth = minWidth;
        newHeight = newWidth / ratio;
        if (newHeight > mediaHeight) {
            newHeight = mediaHeight;
            newWidth = newHeight * ratio;
        }
    }
    else {
        newHeight = minHeight;
        newWidth = newHeight * ratio;
        if (newWidth > mediaWidth) {
            newWidth = mediaWidth;
            newHeight = newWidth / ratio;
        }
    }
    return {
        width: Math.round(newWidth),
        height: Math.round(newHeight),
    };
}
//# sourceMappingURL=media-url-dimensions.js.map